<div cdkDrag [cdkDragData]="data">
    <div [ngClass]="data.placeholderClassName" *cdkDragPlaceholder></div>
    <div [id]="data.id" 
        class="widget-area"
        [ngClass]="data.isSelected ? 'widget-selected' : 'widget-unselected'"
        cdkDropList
        [cdkDropListConnectedTo]="dropListIds"
        [cdkDropListData]="data.children"
        [cdkDropListEnterPredicate]="isDroppableWidget"
        (cdkDropListDropped)="onDrop($event)">

        <!-- Titlebar for Widget -->         
        <div class="widget-top-bar" fxLayout="row nowrap" fxLayoutAlign="end start">
            <mat-icon class="drag-handler" cdkDragHandle>drag_indicator</mat-icon>                   
            <mat-label class="top-bar-title" fxFlex="grow" (click)="onSelect($event)"><b>{{data.name}}</b></mat-label>
            <mat-icon class="top-icon" (click)="onDeleteModal()">delete</mat-icon>
        </div>

        <ng-container *ngFor="let widget of data.children">
            <ng-container [ngSwitch]="widget.widgetType">
                <div appWidgetsRow
                    [data]="$any(widget)"
                    [dropListIds]="dropListIds"
                    (dropListIdAdded)="onDropListIdAdded($event)"
                    *ngSwitchCase="WidgetsTypeEnum.ROW">
                </div>
                <div appWidgetsField
                    [data]="$any(widget)"
                    *ngSwitchCase="WidgetsTypeEnum.FIELD">
                </div>
                <div appWidgetsText
                    [data]="$any(widget)"
                    *ngSwitchCase="WidgetsTypeEnum.TEXT">
                </div>   
                <div appWidgetsRadio
                    [data]="$any(widget)"
                    *ngSwitchCase="WidgetsTypeEnum.RADIO">
                </div>   
                <div appWidgetsRealtedInput
                [data]="$any(widget)"
                *ngSwitchCase="WidgetsTypeEnum.ORDINAL_IN_SET">
            </div>           
                <div appWidgetsRadio
                    [data]="$any(widget)"
                    *ngSwitchCase="WidgetsTypeEnum.INPUT">
                </div>  
                <div appWidgetsQuestion
                    [data]="$any(widget)"
                    *ngSwitchCase="WidgetsTypeEnum.QUESTION">
                </div>
                <div appWidgetsTime
                    [data]="$any(widget)"
                    *ngSwitchCase="WidgetsTypeEnum.TIME_RANGE">
                </div>
            </ng-container>
        </ng-container>
        <!-- <mat-icon class="drag-handler" cdkDragHandle [matBadge]="data.badge">{{data.icon}}</mat-icon>
        <mat-icon class="top-icon" (click)="onDelete()">delete</mat-icon> -->
    </div>
</div>
